import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getCriteriaScoreRanges, updateCriteriaScoreRange } from '../api/criteriaScoreRangeApi'
import type { CriteriaScoreRange, CriteriaScoreRangeUpdate, PagedResponse } from '../types'

const KEY = 'activity-criteria-score-ranges'

/**
 * Değerlendirme Skoru sunucu-durumu (027): liste sorgusu + tek `update` mutation'ı (salt liste + güncelle).
 * Güncel kayıt cache'e yazılır (bayat modDate → 409 önlenir) ve liste invalidate edilir.
 */
export function useCriteriaScoreRanges() {
  const { i18n } = useTranslation()
  const qc = useQueryClient()

  const invalidate = () => {
    qc.invalidateQueries({ queryKey: [KEY] })
  }

  const applyUpdated = (updated: CriteriaScoreRange) =>
    qc.setQueryData<PagedResponse<CriteriaScoreRange>>([KEY, i18n.language], (prev) =>
      prev
        ? { ...prev, content: prev.content.map((r) => (r.id === updated.id ? updated : r)) }
        : prev,
    )

  const list = useQuery({
    queryKey: [KEY, i18n.language],
    queryFn: getCriteriaScoreRanges,
  })

  const update = useMutation({
    mutationFn: ({ id, body }: { id: number; body: CriteriaScoreRangeUpdate }) =>
      updateCriteriaScoreRange(id, body),
    onSuccess: (data) => {
      applyUpdated(data)
      invalidate()
    },
  })

  return { list, update }
}
